import React, { useState, useEffect } from 'react';
import { eventPollOpenAnswers } from '../../../../../api/player';
import { useEventContext } from '../../../context/EventContext';
import { useLocaleContext } from '../../../context/LocaleContext';
import UIButton from '../../../../../globalComponents/UIComponents/UIButton';
import UIInput from '../../Authentication/InputField/UIInput';

export default ({ poll, preview, onAnswer, authorizationCheck }) => {
    const { getProperty, get: getLocale } = useLocaleContext();
    const { event } = useEventContext();
    const [answers, setAnswers] = useState(Array(poll.answerNumber).fill(''));

    useEffect(() => {
        setAnswers(Array(poll.answerNumber).fill(''));
    }, [poll.id])

    const handleChangeAnswer = (index, value) => {
        let newAnswers = [...answers];
        newAnswers[index] = value;
        setAnswers(newAnswers);
    };

    const handleSubmit = async () => {
        if (preview) return;
        
        const isAuth = await authorizationCheck(poll);

        if (isAuth) {
            await eventPollOpenAnswers(event.eventKey, {
                pollId: poll.id,
                answers,
            });
            await onAnswer(poll, answers);
        }
    };

    const isCompleted = answers.filter((value) => value).length > 0; // === poll.answerNumber;

    return (
        <article className={'poll'}>
            {poll.imageUrl && (
                <div className="poll-image-container">
                    <img
                        src={poll.imageUrl}
                        className="poll-image"
                        alt={getProperty(poll, "text")}
                        title={getProperty(poll, "text")}
                    />
                </div>
            )}
            <p className={"poll-text"}>{getProperty(poll, 'text')}</p>
            {answers.map((n, index) => (
                <p key={index}>
                    <UIInput
                        name={'answers[]'}
                        type={'text'}
                        maxLength={600}
                        placeholder={getLocale('polls.enterAnswer')}
                        value={answers[index] || ''}
                        onChange={(value) => handleChangeAnswer(index, value)}
                    />
                </p>
            ))}
            <p>
                <UIButton color="primary" onClick={handleSubmit} disabled={!isCompleted}>
                    {getLocale('polls.answer')}
                </UIButton>
            </p>
        </article>
    );
};
